import { useParams } from 'react-router-dom';
import { useIsAuthenticated } from 'react-auth-kit';
import { InvitationAuthGate } from './components/InvitationAuthGate';
import { InvitationDetails } from './components/InvitationDetails';

export const InvitationPage = () => {
  const { invitationId } = useParams<{ invitationId: string }>();
  const isAuthenticated = useIsAuthenticated();

  if (!invitationId) return null;

  if (!isAuthenticated()) {
    return <InvitationAuthGate />;
  }

  return <InvitationDetails invitationId={invitationId} />;
};
